/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.addJSON({
  client_pb: {
    options: {
      go_package: "./client_pb"
    },
    nested: {
      QCKindsRequest: {
        fields: {}
      },
      QCKindsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kinds: {
            rule: "repeated",
            type: "AIQCKindInfo",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          AIQCKindInfo: {
            fields: {
              kindId: {
                type: "int32",
                id: 1
              },
              kindName: {
                type: "string",
                id: 2
              },
              kindUrl: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      QCPointsRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          }
        }
      },
      QCPointsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindId: {
            type: "int32",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          kindUrl: {
            type: "string",
            id: 5
          },
          code: {
            type: "string",
            id: 6
          },
          points: {
            rule: "repeated",
            type: "Point",
            id: 7
          }
        }
      },
      CreateOcrRequest: {
        fields: {
          points: {
            rule: "repeated",
            type: "PointInfo",
            id: 1
          },
          kindId: {
            type: "int32",
            id: 2
          }
        },
        nested: {
          PointInfo: {
            fields: {
              pointName: {
                type: "string",
                id: 1
              },
              pointId: {
                type: "int32",
                id: 2
              },
              result: {
                type: "string",
                id: 3
              },
              url: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      CreateOcrResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          qcId: {
            type: "string",
            id: 3
          }
        }
      },
      CreateQCRecordsRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          points: {
            rule: "repeated",
            type: "PointInfo",
            id: 2
          }
        },
        nested: {
          PointInfo: {
            fields: {
              url: {
                type: "string",
                id: 1
              },
              pointId: {
                type: "int32",
                id: 2
              }
            }
          }
        }
      },
      CreateQCRecordsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          qcId: {
            type: "string",
            id: 3
          }
        }
      },
      CreatePointRecordRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          },
          pointId: {
            type: "int32",
            id: 3
          }
        }
      },
      CreatePointRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pointRecordId: {
            type: "int32",
            id: 3
          },
          infos: {
            rule: "repeated",
            type: "ResultInfo",
            id: 4
          },
          origSize: {
            type: "string",
            id: 5
          }
        },
        nested: {
          ResultInfo: {
            fields: {
              key: {
                type: "string",
                id: 1
              },
              label: {
                type: "string",
                id: 2
              },
              type: {
                type: "string",
                id: 3
              },
              useType: {
                type: "string",
                id: 4
              },
              value: {
                type: "string",
                id: 5
              },
              pointTypeName: {
                type: "string",
                id: 6
              }
            }
          }
        }
      },
      CreateQCRecordsV2Request: {
        fields: {
          pointRecordIds: {
            rule: "repeated",
            type: "int32",
            id: 1
          }
        }
      },
      CreateQCRecordsV2Response: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          qcId: {
            type: "string",
            id: 3
          }
        }
      },
      QCRecordListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      QCRecordListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          records: {
            rule: "repeated",
            type: "QCRecord",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          QCRecord: {
            fields: {
              qcId: {
                type: "string",
                id: 1
              },
              url: {
                type: "string",
                id: 2
              },
              result: {
                type: "int32",
                id: 3
              },
              createdAt: {
                type: "string",
                id: 4
              },
              kindName: {
                type: "string",
                id: 5
              }
            }
          }
        }
      },
      QCRecordDetailRequest: {
        fields: {
          qcId: {
            type: "string",
            id: 1
          }
        }
      },
      QCRecordDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          detail: {
            type: "QCRecordDetail",
            id: 3
          }
        },
        nested: {
          QCRecordDetail: {
            fields: {
              uid: {
                type: "int32",
                id: 1
              },
              qcId: {
                type: "string",
                id: 2
              },
              points: {
                rule: "repeated",
                type: "PointResult",
                id: 3
              },
              remark: {
                type: "string",
                id: 4
              },
              result: {
                type: "int32",
                id: 5
              }
            }
          },
          PointResult: {
            fields: {
              pointId: {
                type: "int32",
                id: 1
              },
              pointName: {
                type: "string",
                id: 2
              },
              image: {
                type: "string",
                id: 3
              },
              checkStatus: {
                type: "int32",
                id: 4
              },
              defects: {
                rule: "repeated",
                type: "string",
                id: 5
              },
              infos: {
                rule: "repeated",
                type: "ResultInfo",
                id: 6
              },
              origSize: {
                type: "string",
                id: 7
              }
            },
            nested: {
              ResultInfo: {
                fields: {
                  key: {
                    type: "string",
                    id: 1
                  },
                  label: {
                    type: "string",
                    id: 2
                  },
                  type: {
                    type: "string",
                    id: 3
                  },
                  useType: {
                    type: "string",
                    id: 4
                  },
                  value: {
                    type: "string",
                    id: 5
                  },
                  pointTypeName: {
                    type: "string",
                    id: 6
                  }
                }
              }
            }
          }
        }
      },
      CategoryInitial: {
        fields: {
          letter: {
            type: "string",
            id: 1
          },
          categoryInfos: {
            rule: "repeated",
            type: "CategoryInfo",
            id: 2
          }
        }
      },
      CategoryInfo: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          enName: {
            type: "string",
            id: 2
          },
          images: {
            type: "ImageInfo",
            id: 3
          },
          categoryId: {
            type: "int32",
            id: 4
          },
          isEnd: {
            type: "bool",
            id: 5
          },
          hotSequence: {
            type: "int32",
            id: 6
          },
          appraisalType: {
            type: "AppraisalType",
            id: 7
          }
        }
      },
      ImageInfo: {
        fields: {
          hdImage: {
            type: "string",
            id: 1
          },
          normalImage: {
            type: "string",
            id: 2
          },
          thumbImage: {
            type: "string",
            id: 3
          }
        }
      },
      AppraisalPoint: {
        fields: {
          pointId: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          pointType: {
            type: "PointType",
            id: 3
          },
          photoGuide: {
            type: "string",
            id: 4
          },
          exampleImage: {
            type: "string",
            id: 5
          },
          stickFigureImage: {
            type: "string",
            id: 6
          },
          bigStickFigureImage: {
            type: "string",
            id: 7
          },
          must: {
            type: "bool",
            id: 8
          },
          necessity: {
            type: "bool",
            id: 9
          },
          singleKey: {
            type: "string",
            id: 10
          },
          pointKey: {
            type: "string",
            id: 11
          }
        }
      },
      SingleAppraisalBox: {
        fields: {
          x: {
            type: "string",
            id: 1
          },
          y: {
            type: "string",
            id: 2
          },
          width: {
            type: "string",
            id: 3
          },
          height: {
            type: "string",
            id: 4
          },
          radius: {
            type: "string",
            id: 5
          }
        }
      },
      SingleRecord: {
        fields: {
          saId: {
            type: "string",
            id: 1
          },
          image: {
            type: "string",
            id: 2
          },
          pointName: {
            type: "string",
            id: 3
          },
          grade: {
            type: "string",
            id: 4
          },
          description: {
            type: "string",
            id: 5
          },
          manualReview: {
            type: "EyeglassManualReview",
            id: 6
          },
          remark: {
            type: "string",
            id: 7
          }
        }
      },
      Point: {
        fields: {
          pointId: {
            type: "int32",
            id: 1
          },
          pointName: {
            type: "string",
            id: 2
          },
          seq: {
            type: "int32",
            id: 3
          }
        }
      },
      RoleType: {
        values: {
          ROLE_TYPE_DEFAULT: 0,
          ROLE_TYPE_USER: 1,
          ROLE_TYPE_ASSISTANT: 2
        }
      },
      AppraisalType: {
        values: {
          APPRAISAL_TYPE_DEFAULT: 0,
          APPRAISAL_TYPE_AI: 1,
          APPRAISAL_TYPE_MANUAL: 2
        }
      },
      CategoryType: {
        values: {
          CATEGORY_TYPE_DEFAULT: 0,
          CATEGORY_TYPE_KIND: 1,
          CATEGORY_TYPE_BRAND: 2,
          CATEGORY_TYPE_SERIES: 3
        }
      },
      PointType: {
        values: {
          POINT_TYPE_DEFAULT: 0,
          POINT_TYPE_APPRAISAL: 1,
          POINT_TYPE_NON_APPRAISAL: 2
        }
      },
      OrderSource: {
        values: {
          ORDER_SOURCE_DEFAULT: 0,
          ORDER_SOURCE_AI_QUALITY_INSPECTION_MINI_PROGRAM: 1,
          ORDER_SOURCE_VIDEO_DETECTION: 2
        }
      },
      AppraisalResult: {
        values: {
          APPRAISAL_RESULT_DEFAULT: 0,
          APPRAISAL_RESULT_TRUE: 1,
          APPRAISAL_RESULT_FALSE: 2,
          APPRAISAL_RESULT_UNKNOWN: 3
        }
      },
      ManualAppraisalResult: {
        values: {
          MANUAL_APPRAISAL_RESULT_DEFAULT: 0,
          MANUAL_APPRAISAL_RESULT_TRUE: 1,
          MANUAL_APPRAISAL_RESULT_FALSE: 2,
          MANUAL_APPRAISAL_RESULT_UNKNOWN: 3
        }
      },
      EyeglassClassifyType: {
        values: {
          EYEGLASS_CLASSIFY_TYPE_DEFAULT: 0,
          EYEGLASS_CLASSIFY_TYPE_LIMIT: 1,
          EYEGLASS_CLASSIFY_TYPE_OTHER: 2
        }
      },
      EyeglassManualReview: {
        values: {
          EYEGLASS_MANUAL_REVIEW_DEFAULT: 0,
          EYEGLASS_MANUAL_REVIEW_TRUE: 1,
          EYEGLASS_MANUAL_REVIEW_FALSE: 2
        }
      },
      EyeglassDeviceType: {
        values: {
          EYEGLASS_DEVICE_TYPE_DEFAULT: 0,
          EYEGLASS_DEVICE_TYPE_EYEGLASS: 1,
          EYEGLASS_DEVICE_TYPE_APP: 2,
          EYEGLASS_DEVICE_TYPE_H5: 3,
          EYEGLASS_DEVICE_TYPE_PC: 4,
          EYEGLASS_DEVICE_TYPE_GPY: 5
        }
      },
      ChannelType: {
        values: {
          CHANNEL_TYPE_DEFAULT: 0,
          CHANNEL_TYPE_CLIENT: 1,
          CHANNEL_TYPE_SERVER: 2
        }
      },
      AssessmentListRequest: {
        fields: {}
      },
      AssessmentListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          assessment: {
            rule: "repeated",
            type: "AssessmentItem",
            id: 3
          }
        }
      },
      AssessmentItem: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          describe: {
            type: "string",
            id: 2
          },
          timeLimit: {
            type: "int32",
            id: 3
          },
          kindId: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandId: {
            type: "int32",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesId: {
            rule: "repeated",
            type: "int32",
            id: 8
          },
          seriesName: {
            rule: "repeated",
            type: "string",
            id: 9
          },
          num: {
            type: "int32",
            id: 10
          },
          numberOfRetakesPossible: {
            type: "int32",
            id: 11
          },
          images: {
            type: "string",
            id: 12
          },
          examPaperId: {
            type: "string",
            id: 13
          },
          brandIds: {
            rule: "repeated",
            type: "int32",
            id: 14
          },
          brandNames: {
            rule: "repeated",
            type: "string",
            id: 15
          }
        }
      },
      AnswerRecordRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      AnswerRecordResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          answerRecord: {
            rule: "repeated",
            type: "AnswerRecordItem",
            id: 3
          }
        }
      },
      AnswerRecordItem: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          },
          accuracy: {
            type: "float",
            id: 3
          },
          speedTime: {
            type: "int32",
            id: 4
          },
          startTime: {
            type: "string",
            id: 5
          },
          status: {
            type: "int32",
            id: 6
          },
          examNumber: {
            type: "string",
            id: 7
          },
          firstImage: {
            type: "string",
            id: 8
          },
          issuedResult: {
            type: "int32",
            id: 9
          }
        }
      },
      AnswerDetailRequest: {
        fields: {
          examNumber: {
            type: "string",
            id: 1
          }
        }
      },
      AnswerDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          answerRecord: {
            type: "AnswerRecordItem",
            id: 3
          },
          answerDetail: {
            rule: "repeated",
            type: "AnswerDetail",
            id: 4
          }
        }
      },
      AnswerDetail: {
        fields: {
          topic: {
            type: "Topic",
            id: 1
          },
          examinee: {
            type: "Examinee",
            id: 2
          },
          isRight: {
            type: "int32",
            id: 3
          }
        }
      },
      Topic: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          describe: {
            type: "string",
            id: 2
          },
          genuine: {
            type: "int32",
            id: 3
          },
          parse: {
            type: "string",
            id: 4
          },
          questionOrder: {
            type: "string",
            id: 5
          },
          images: {
            rule: "repeated",
            type: "string",
            id: 6
          },
          watermarkImages: {
            rule: "repeated",
            type: "string",
            id: 7
          }
        }
      },
      Examinee: {
        fields: {
          answer: {
            type: "int32",
            id: 1
          },
          accordance: {
            type: "string",
            id: 2
          }
        }
      },
      AnswerQuestionsRequest: {
        fields: {
          examPaperId: {
            type: "string",
            id: 1
          }
        }
      },
      AnswerQuestionsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          examNumber: {
            type: "string",
            id: 3
          },
          questions: {
            rule: "repeated",
            type: "QuestionItem",
            id: 4
          }
        }
      },
      QuestionItem: {
        fields: {
          id: {
            type: "string",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          describe: {
            type: "string",
            id: 3
          },
          images: {
            rule: "repeated",
            type: "string",
            id: 4
          }
        }
      },
      StopAnswerQuestionsRequest: {
        fields: {
          examNumber: {
            type: "string",
            id: 1
          }
        }
      },
      StopAnswerQuestionsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      SubmitRequest: {
        fields: {
          timuId: {
            type: "string",
            id: 1
          },
          examNumber: {
            type: "string",
            id: 2
          },
          genuine: {
            type: "int32",
            id: 3
          },
          remark: {
            type: "string",
            id: 4
          }
        }
      },
      SubmitResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      SuspectedOfCheatingAddRequest: {
        fields: {
          examNumber: {
            type: "string",
            id: 1
          },
          type: {
            type: "int32",
            id: 2
          },
          screenshot: {
            type: "string",
            id: 4
          },
          mobilePhoneDevicesOrder: {
            type: "string",
            id: 5
          }
        }
      },
      SuspectedOfCheatingAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cheatingId: {
            type: "string",
            id: 3
          },
          Screenshottimes: {
            type: "int32",
            id: 4
          }
        }
      },
      CheckExamNumberRequest: {
        fields: {
          brandId: {
            type: "int32",
            id: 1
          }
        }
      },
      CheckExamNumberResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          responseCode: {
            type: "int32",
            id: 3
          },
          responseMessage: {
            type: "string",
            id: 4
          }
        }
      },
      CheckQuestionBankRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          brandId: {
            type: "int32",
            id: 2
          },
          seriesIds: {
            rule: "repeated",
            type: "int32",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          brandName: {
            type: "string",
            id: 5
          }
        }
      },
      CheckQuestionBankResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          questionBankFull: {
            rule: "repeated",
            type: "CategoryBaseInfo",
            id: 3
          },
          questionBankNotFull: {
            rule: "repeated",
            type: "CategoryBaseInfo",
            id: 4
          },
          StandardQuestionBank: {
            type: "int32",
            id: 5
          }
        }
      },
      CategoryBaseInfo: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          brandId: {
            type: "int32",
            id: 2
          },
          seriesId: {
            type: "int32",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          brandName: {
            type: "string",
            id: 5
          },
          seriesName: {
            type: "string",
            id: 6
          },
          questionNum: {
            type: "int32",
            id: 7
          }
        }
      },
      ClientGenerateExamPaperRequest: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          describe: {
            type: "string",
            id: 2
          },
          kindId: {
            type: "int32",
            id: 4
          },
          brandId: {
            type: "int32",
            id: 5
          },
          seriesIds: {
            rule: "repeated",
            type: "int32",
            id: 6
          },
          source: {
            type: "int32",
            id: 7
          }
        }
      },
      ClientGenerateExamPaperResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ExamPaperIds: {
            rule: "repeated",
            type: "string",
            id: 3
          }
        }
      },
      StartExamRequest: {
        fields: {
          examPaperId: {
            type: "string",
            id: 1
          }
        }
      },
      StartExamResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          examNumber: {
            type: "string",
            id: 3
          },
          questions: {
            rule: "repeated",
            type: "QuestionItem",
            id: 4
          },
          title: {
            type: "string",
            id: 5
          },
          limitTime: {
            type: "int32",
            id: 6
          }
        }
      },
      ClientQuestionBankFeedbackRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          brandId: {
            type: "string",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          seriesId: {
            type: "string",
            id: 5
          },
          seriesName: {
            type: "string",
            id: 6
          },
          feedbackType: {
            type: "int32",
            id: 7
          },
          remark: {
            type: "string",
            id: 8
          }
        }
      },
      ClientQuestionBankFeedbackResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      BlacklistAddRequest: {
        fields: {
          mobilePhoneDevicesOrder: {
            type: "string",
            id: 1
          }
        }
      },
      BlacklistAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      BlacklistCheckRequest: {
        fields: {
          mobilePhoneDevicesOrder: {
            type: "string",
            id: 1
          }
        }
      },
      BlacklistCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          responseCode: {
            type: "int32",
            id: 3
          }
        }
      },
      GetAppraisalPointsRequest: {
        fields: {
          categoryType: {
            type: "CategoryType",
            id: 1
          },
          categoryId: {
            type: "int32",
            id: 2
          },
          appraisalType: {
            type: "int32",
            id: 3
          }
        }
      },
      GetAppraisalPointsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          categoryName: {
            type: "string",
            id: 3
          },
          categoryEnName: {
            type: "string",
            id: 4
          },
          categoryImage: {
            type: "string",
            id: 5
          },
          points: {
            rule: "repeated",
            type: "AppraisalPoint",
            id: 6
          },
          nonPoints: {
            rule: "repeated",
            type: "AppraisalPoint",
            id: 7
          },
          mustNum: {
            type: "int32",
            id: 8
          }
        }
      },
      AppraisalRecordsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          search: {
            type: "string",
            id: 3
          },
          kindId: {
            type: "int32",
            id: 4
          }
        }
      },
      AppraisalRecordsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          records: {
            rule: "repeated",
            type: "AppraisalRecord",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          AppraisalRecord: {
            fields: {
              oaId: {
                type: "string",
                id: 1
              },
              coverImage: {
                type: "string",
                id: 2
              },
              createTime: {
                type: "string",
                id: 3
              },
              hierarchy: {
                type: "string",
                id: 4
              },
              kindName: {
                type: "string",
                id: 5
              },
              brandName: {
                type: "string",
                id: 6
              },
              seriesName: {
                type: "string",
                id: 7
              },
              result: {
                type: "AppraisalResult",
                id: 8
              },
              appraisalType: {
                type: "AppraisalType",
                id: 9
              }
            }
          }
        }
      },
      AppraisalReportRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          }
        }
      },
      AppraisalReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          oaId: {
            type: "string",
            id: 3
          },
          result: {
            type: "AppraisalResult",
            id: 4
          },
          hierarchy: {
            type: "string",
            id: 5
          },
          kindName: {
            type: "string",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesName: {
            type: "string",
            id: 8
          },
          createTime: {
            type: "string",
            id: 9
          },
          coverImage: {
            type: "string",
            id: 10
          },
          singleRecords: {
            rule: "repeated",
            type: "SingleRecord",
            id: 11
          }
        }
      },
      EyeglassAppraisalRequest: {
        fields: {
          result: {
            type: "AppraisalResult",
            id: 1
          },
          grade: {
            type: "float",
            id: 2
          },
          description: {
            type: "string",
            id: 3
          },
          needCheck: {
            type: "bool",
            id: 4
          },
          params: {
            rule: "repeated",
            type: "SingleParam",
            id: 5
          }
        },
        nested: {
          SingleParam: {
            fields: {
              pointId: {
                type: "int32",
                id: 1
              },
              imageB64: {
                type: "string",
                id: 2
              },
              grade: {
                type: "float",
                id: 3
              },
              genuineStandard: {
                type: "float",
                id: 4
              },
              showFake: {
                type: "bool",
                id: 5
              },
              genuine: {
                type: "bool",
                id: 6
              },
              originalBox: {
                type: "string",
                id: 7
              },
              detectionBox: {
                type: "string",
                id: 8
              },
              fakePoints: {
                type: "string",
                id: 9
              },
              description: {
                type: "string",
                id: 10
              }
            }
          }
        }
      },
      EyeglassAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          oaId: {
            type: "string",
            id: 3
          }
        }
      },
      EyeglassArtificialAppraisalRequest: {
        fields: {
          appraisorId: {
            type: "int32",
            id: 1
          },
          params: {
            rule: "repeated",
            type: "SingleParam",
            id: 2
          }
        },
        nested: {
          SingleParam: {
            fields: {
              pointId: {
                type: "int32",
                id: 1
              },
              imageB64: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      EyeglassArtificialAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          oaId: {
            type: "string",
            id: 3
          }
        }
      },
      CheckEyeglassVersionRequest: {
        fields: {}
      },
      CheckEyeglassVersionResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          latestVersion: {
            type: "string",
            id: 3
          },
          latestVersionDownloadUrl: {
            type: "string",
            id: 4
          }
        }
      },
      EyeglassSkinCheckRequest: {
        fields: {
          imageB64: {
            type: "string",
            id: 1
          },
          faceNums: {
            type: "int32",
            id: 2
          },
          showBox: {
            type: "string",
            id: 3
          },
          grade: {
            type: "float",
            id: 4
          },
          detectGlasses: {
            type: "bool",
            id: 5
          },
          points: {
            rule: "repeated",
            type: "Point",
            id: 6
          }
        },
        nested: {
          Point: {
            fields: {
              type: {
                type: "string",
                id: 1
              },
              grade: {
                type: "float",
                id: 2
              },
              coordinates: {
                type: "Coordinates",
                id: 3
              }
            }
          },
          Coordinates: {
            fields: {
              x: {
                type: "int32",
                id: 1
              },
              y: {
                type: "int32",
                id: 2
              }
            }
          }
        }
      },
      EyeglassSkinCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TeaAppraisalRequest: {
        fields: {
          image: {
            type: "string",
            id: 1
          }
        }
      },
      TeaAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          checkId: {
            type: "string",
            id: 3
          },
          detectionBox: {
            type: "SingleAppraisalBox",
            id: 4
          },
          originalBox: {
            type: "SingleAppraisalBox",
            id: 5
          },
          area: {
            type: "string",
            id: 6
          },
          areaGrade: {
            type: "string",
            id: 7
          },
          newAged: {
            type: "string",
            id: 8
          },
          newAgedGrade: {
            type: "string",
            id: 9
          },
          image: {
            type: "string",
            id: 10
          }
        }
      },
      SkinQualityCheckRequest: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          },
          angle: {
            type: "Angle",
            id: 2
          }
        },
        nested: {
          Angle: {
            values: {
              DEFAULT: 0,
              FRONT: 1,
              LEFT: 2,
              RIGHT: 3
            }
          }
        }
      },
      SkinQualityCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          isFace: {
            type: "bool",
            id: 3
          },
          originalBox: {
            type: "SingleAppraisalBox",
            id: 4
          },
          results: {
            rule: "repeated",
            type: "Result",
            id: 5
          },
          summary: {
            type: "string",
            id: 6
          }
        },
        nested: {
          Result: {
            fields: {
              type: {
                type: "RegionType",
                id: 1
              },
              region: {
                type: "string",
                id: 2
              },
              fusion: {
                type: "string",
                id: 3
              },
              grade: {
                type: "string",
                id: 4
              },
              description: {
                type: "string",
                id: 5
              },
              totallen: {
                type: "string",
                id: 6
              },
              maxlen: {
                type: "string",
                id: 7
              },
              arearatio: {
                type: "string",
                id: 8
              }
            }
          },
          RegionType: {
            values: {
              DEFAULT: 0,
              LEFT_WRINKLE: 1,
              RIGHT_WRINKLE: 2,
              CROWS_FEET: 3
            }
          }
        }
      },
      CardRecognitionGetIdCardTextRequest: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          }
        }
      },
      CardRecognitionCheckRequest: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          }
        }
      },
      CardRecognitionCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMessage: {
            type: "string",
            id: 2
          },
          idCardInfo: {
            type: "IdCardInfo",
            id: 3
          }
        }
      },
      IdCardInfo: {
        fields: {
          idNumber: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          gender: {
            type: "string",
            id: 3
          },
          ethnicity: {
            type: "string",
            id: 4
          },
          dateOfBirth: {
            type: "string",
            id: 5
          },
          address: {
            type: "string",
            id: 6
          }
        }
      },
      GetKindsRequest: {
        fields: {}
      },
      GetKindsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kinds: {
            rule: "repeated",
            type: "CategoryInfo",
            id: 3
          }
        }
      },
      GetBrandsRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          appraisalType: {
            type: "int32",
            id: 2
          }
        }
      },
      GetBrandsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brands: {
            rule: "repeated",
            type: "CategoryInitial",
            id: 3
          }
        }
      },
      GetSeriesRequest: {
        fields: {
          brandId: {
            type: "int32",
            id: 1
          },
          appraisalType: {
            type: "int32",
            id: 2
          }
        }
      },
      GetSeriesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          series: {
            rule: "repeated",
            type: "CategoryInitial",
            id: 3
          }
        }
      },
      GetChatHistoryRequest: {
        fields: {
          messageIndex: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      GetChatHistoryResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          total: {
            type: "int32",
            id: 3
          },
          messages: {
            rule: "repeated",
            type: "ChatMessage",
            id: 4
          }
        },
        nested: {
          ChatMessage: {
            fields: {
              role: {
                type: "RoleType",
                id: 1
              },
              content: {
                type: "string",
                id: 2
              },
              index: {
                type: "int32",
                id: 3
              },
              timestamp: {
                type: "int64",
                id: 4
              },
              messageId: {
                type: "string",
                id: 5
              }
            }
          }
        }
      },
      ClassifyImageUseLLMRequest: {
        fields: {
          image: {
            type: "string",
            id: 1
          }
        }
      },
      ClassifyImageUseLLMResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          seriesName: {
            type: "string",
            id: 5
          }
        }
      },
      LLMSummaryRequest: {
        fields: {
          content: {
            type: "string",
            id: 1
          }
        }
      },
      LLMSummaryResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          summary: {
            type: "string",
            id: 3
          }
        }
      },
      LLMOcrRequest: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          }
        }
      },
      LLMOcrResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          }
        }
      },
      ExperienceService: {
        methods: {
          Ocr: {
            requestType: "LLMOcrRequest",
            responseType: "LLMOcrResponse"
          }
        }
      },
      EyeglassClassifyRequest: {
        fields: {
          deviceId: {
            type: "string",
            id: 1
          },
          imageB64: {
            type: "string",
            id: 2
          },
          deviceType: {
            type: "EyeglassDeviceType",
            id: 3
          }
        }
      },
      EyeglassClassifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          classifyId: {
            type: "string",
            id: 3
          },
          match: {
            type: "bool",
            id: 4
          },
          kindId: {
            type: "int32",
            id: 5
          },
          kindName: {
            type: "string",
            id: 6
          },
          brandId: {
            type: "int32",
            id: 7
          },
          brandName: {
            type: "string",
            id: 8
          },
          seriesId: {
            type: "int32",
            id: 9
          },
          seriesName: {
            type: "string",
            id: 10
          },
          other: {
            type: "string",
            id: 11
          },
          summary: {
            type: "string",
            id: 12
          },
          description: {
            type: "string",
            id: 13
          }
        }
      },
      EyeglassIdentifyRequest: {
        fields: {
          deviceId: {
            type: "string",
            id: 1
          },
          classifyId: {
            type: "string",
            id: 2
          },
          result: {
            type: "AppraisalResult",
            id: 3
          },
          grade: {
            type: "float",
            id: 4
          },
          description: {
            type: "string",
            id: 5
          },
          params: {
            rule: "repeated",
            type: "SingleParam",
            id: 6
          },
          deviceType: {
            type: "EyeglassDeviceType",
            id: 7
          },
          channelType: {
            type: "ChannelType",
            id: 8
          },
          serialNum: {
            type: "string",
            id: 9
          }
        },
        nested: {
          SingleParam: {
            fields: {
              pointId: {
                type: "int32",
                id: 1
              },
              imageB64: {
                type: "string",
                id: 2
              },
              grade: {
                type: "float",
                id: 3
              },
              genuineStandard: {
                type: "float",
                id: 4
              },
              showFake: {
                type: "bool",
                id: 5
              },
              genuine: {
                type: "bool",
                id: 6
              },
              originalBox: {
                type: "string",
                id: 7
              },
              detectionBox: {
                type: "string",
                id: 8
              },
              fakePoints: {
                type: "string",
                id: 9
              },
              description: {
                type: "string",
                id: 10
              },
              imageUrl: {
                type: "string",
                id: 11
              }
            }
          }
        }
      },
      EyeglassIdentifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraisalInfo: {
            type: "AppraisalInfo",
            id: 3
          },
          oaId: {
            type: "string",
            id: 4
          }
        },
        nested: {
          AppraisalInfo: {
            fields: {
              KindId: {
                type: "int32",
                id: 1
              },
              KindName: {
                type: "string",
                id: 2
              },
              BrandId: {
                type: "int32",
                id: 3
              },
              BrandName: {
                type: "string",
                id: 4
              },
              SeriesId: {
                type: "int32",
                id: 5
              },
              SeriesName: {
                type: "string",
                id: 6
              },
              PointName: {
                type: "string",
                id: 7
              },
              BrandEnName: {
                type: "string",
                id: 8
              },
              AppraisalType: {
                type: "int32",
                id: 9
              },
              Hierarchy: {
                type: "string",
                id: 10
              }
            }
          }
        }
      },
      EyeglassClassifyRecordsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          classifyType: {
            type: "EyeglassClassifyType",
            id: 3
          },
          deviceType: {
            type: "EyeglassDeviceType",
            id: 4
          },
          createTime: {
            type: "string",
            id: 5
          },
          endTime: {
            type: "string",
            id: 6
          }
        }
      },
      EyeglassClassifyRecordsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          data: {
            rule: "repeated",
            type: "Record",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          Record: {
            fields: {
              classifyId: {
                type: "string",
                id: 1
              },
              image: {
                type: "string",
                id: 2
              },
              classifyTime: {
                type: "string",
                id: 3
              },
              deviceId: {
                type: "string",
                id: 4
              },
              confidenceGrade: {
                type: "string",
                id: 5
              },
              classifyType: {
                type: "EyeglassClassifyType",
                id: 6
              },
              manualReview: {
                type: "EyeglassManualReview",
                id: 7
              },
              remark: {
                type: "string",
                id: 8
              },
              uid: {
                type: "string",
                id: 9
              },
              deviceType: {
                type: "EyeglassDeviceType",
                id: 10
              },
              result: {
                type: "string",
                id: 11
              },
              username: {
                type: "string",
                id: 12
              }
            }
          }
        }
      },
      EyeglassClassifyDetailRequest: {
        fields: {
          classifyId: {
            type: "string",
            id: 1
          }
        }
      },
      EyeglassClassifyDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          data: {
            rule: "repeated",
            type: "Record",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          Record: {
            fields: {
              classifyId: {
                type: "string",
                id: 1
              },
              image: {
                type: "string",
                id: 2
              },
              classifyTime: {
                type: "string",
                id: 3
              },
              kindName: {
                type: "string",
                id: 4
              },
              brandName: {
                type: "string",
                id: 5
              },
              seriesName: {
                type: "string",
                id: 6
              },
              deviceId: {
                type: "string",
                id: 7
              },
              confidenceGrade: {
                type: "string",
                id: 8
              },
              classifyType: {
                type: "EyeglassClassifyType",
                id: 9
              },
              manualReview: {
                type: "EyeglassManualReview",
                id: 10
              },
              remark: {
                type: "string",
                id: 11
              },
              uid: {
                type: "string",
                id: 12
              },
              deviceType: {
                type: "EyeglassDeviceType",
                id: 13
              },
              username: {
                type: "string",
                id: 14
              },
              phone: {
                type: "string",
                id: 15
              }
            }
          }
        }
      },
      EyeglassIdentifyRecordsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          result: {
            type: "AppraisalResult",
            id: 3
          },
          deviceType: {
            type: "EyeglassDeviceType",
            id: 4
          },
          createTime: {
            type: "string",
            id: 5
          },
          endTime: {
            type: "string",
            id: 6
          },
          KindId: {
            type: "int32",
            id: 7
          }
        }
      },
      EyeglassIdentifyRecordsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          data: {
            rule: "repeated",
            type: "Record",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          Record: {
            fields: {
              classifyId: {
                type: "string",
                id: 1
              },
              identifyTime: {
                type: "string",
                id: 2
              },
              result: {
                type: "AppraisalResult",
                id: 3
              },
              oaId: {
                type: "string",
                id: 4
              },
              deviceId: {
                type: "string",
                id: 5
              },
              uid: {
                type: "string",
                id: 6
              },
              deviceType: {
                type: "EyeglassDeviceType",
                id: 7
              },
              description: {
                type: "string",
                id: 8
              },
              image: {
                type: "string",
                id: 9
              },
              kindName: {
                type: "string",
                id: 10
              },
              brandName: {
                type: "string",
                id: 11
              },
              seriesName: {
                type: "string",
                id: 12
              },
              grade: {
                type: "string",
                id: 13
              },
              channelType: {
                type: "ChannelType",
                id: 14
              },
              username: {
                type: "string",
                id: 15
              }
            }
          }
        }
      },
      EyeglassIdentifyDetailRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          }
        }
      },
      EyeglassIdentifyDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          classifyId: {
            type: "string",
            id: 3
          },
          identifyTime: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          seriesName: {
            type: "string",
            id: 7
          },
          result: {
            type: "AppraisalResult",
            id: 8
          },
          grade: {
            type: "string",
            id: 9
          },
          description: {
            type: "string",
            id: 10
          },
          singleRecords: {
            rule: "repeated",
            type: "SingleRecord",
            id: 11
          },
          deviceId: {
            type: "string",
            id: 12
          },
          uid: {
            type: "string",
            id: 13
          },
          deviceType: {
            type: "EyeglassDeviceType",
            id: 14
          },
          oaId: {
            type: "string",
            id: 15
          },
          channelType: {
            type: "ChannelType",
            id: 16
          },
          username: {
            type: "string",
            id: 17
          },
          phone: {
            type: "string",
            id: 18
          }
        }
      },
      EyeglassClassifyReviewRequest: {
        fields: {
          classifyId: {
            type: "string",
            id: 1
          },
          manualReview: {
            type: "EyeglassManualReview",
            id: 2
          },
          remark: {
            type: "string",
            id: 3
          }
        }
      },
      EyeglassClassifyReviewResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      EyeglassIdentifyDetailReviewRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          },
          saId: {
            type: "string",
            id: 2
          },
          manualReview: {
            type: "EyeglassManualReview",
            id: 3
          },
          remark: {
            type: "string",
            id: 4
          }
        }
      },
      EyeglassIdentifyDetailReviewResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      EyeglassGetPromissionUserInfoRequest: {
        fields: {}
      },
      EyeglassGetPromissionUserInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          realName: {
            type: "string",
            id: 3
          },
          phone: {
            type: "string",
            id: 4
          },
          imageUrl: {
            type: "string",
            id: 5
          },
          promissionType: {
            type: "string",
            id: 6
          },
          uid: {
            type: "int32",
            id: 7
          }
        }
      },
      VideoDetectionTagDetailRequest: {
        fields: {
          serialNum: {
            type: "string",
            id: 1
          }
        }
      },
      VideoDetectionTagDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          serialNum: {
            type: "string",
            id: 3
          },
          kindId: {
            type: "int32",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandId: {
            type: "int32",
            id: 6
          },
          brandName: {
            type: "string",
            id: 7
          },
          seriesId: {
            type: "int32",
            id: 8
          },
          seriesName: {
            type: "string",
            id: 9
          },
          exampleUrl: {
            type: "string",
            id: 10
          },
          enable: {
            type: "bool",
            id: 11
          }
        }
      },
      VideoDetectionReportRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          },
          serialNum: {
            type: "string",
            id: 2
          }
        }
      },
      VideoDetectionReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          oaId: {
            type: "string",
            id: 3
          },
          appraisalTime: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          seriesName: {
            type: "string",
            id: 7
          },
          aiResult: {
            type: "AppraisalResult",
            id: 8
          },
          manualResult: {
            type: "ManualAppraisalResult",
            id: 9
          },
          grade: {
            type: "string",
            id: 10
          },
          description: {
            type: "string",
            id: 11
          },
          singleRecords: {
            rule: "repeated",
            type: "SingleRecord",
            id: 12
          }
        }
      },
      QualityInspectionSubmitRequest: {
        fields: {
          productNo: {
            type: "string",
            id: 1
          },
          kind: {
            type: "int32",
            id: 2
          },
          style: {
            type: "int32",
            id: 3
          },
          brand: {
            type: "int32",
            id: 4
          },
          series: {
            type: "int32",
            id: 5
          },
          images: {
            rule: "repeated",
            type: "InspectionImage",
            id: 6
          }
        }
      },
      InspectionImage: {
        fields: {
          imageName: {
            type: "string",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          }
        }
      },
      QualityInspectionSubmitResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          inspectionNo: {
            type: "string",
            id: 3
          }
        }
      },
      QualityInspectionListRequest: {
        fields: {
          inspectionNo: {
            type: "string",
            id: 1
          },
          productNo: {
            type: "string",
            id: 2
          },
          flawNums: {
            type: "int32",
            id: 3
          },
          kind: {
            type: "int32",
            id: 4
          },
          style: {
            type: "int32",
            id: 5
          },
          brand: {
            type: "int32",
            id: 6
          },
          series: {
            type: "int32",
            id: 7
          },
          startTime: {
            type: "string",
            id: 8
          },
          endTime: {
            type: "string",
            id: 9
          },
          pageNum: {
            type: "int32",
            id: 10
          },
          pageSize: {
            type: "int32",
            id: 11
          },
          flawStatus: {
            type: "int32",
            id: 12
          },
          sizeStatus: {
            type: "int32",
            id: 13
          }
        }
      },
      InspectionList: {
        fields: {
          inspectionNo: {
            type: "string",
            id: 1
          },
          productNo: {
            type: "string",
            id: 2
          },
          createTime: {
            type: "string",
            id: 3
          },
          updateTime: {
            type: "string",
            id: 4
          },
          kindId: {
            type: "int32",
            id: 5
          },
          kindName: {
            type: "string",
            id: 6
          },
          style: {
            type: "int32",
            id: 7
          },
          brandId: {
            type: "int32",
            id: 8
          },
          brandName: {
            type: "string",
            id: 9
          },
          seriesId: {
            type: "int32",
            id: 10
          },
          seriesName: {
            type: "string",
            id: 11
          },
          flawNums: {
            type: "int32",
            id: 12
          },
          level: {
            type: "int32",
            id: 13
          },
          flawStatus: {
            type: "int32",
            id: 14
          },
          sizeStatus: {
            type: "int32",
            id: 15
          },
          unitResult: {
            type: "double",
            id: 16
          },
          unitUint: {
            type: "int32",
            id: 17
          },
          unitValue: {
            type: "int32",
            id: 18
          }
        }
      },
      QualityInspectionListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          inspectionList: {
            rule: "repeated",
            type: "InspectionList",
            id: 3
          },
          count: {
            type: "int32",
            id: 4
          }
        }
      },
      QualityInspectionFlawResultRequest: {
        fields: {
          inspectionNo: {
            type: "string",
            id: 1
          }
        }
      },
      InspectionFlawResult: {
        fields: {
          imageName: {
            type: "string",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          },
          flawList: {
            rule: "repeated",
            type: "FlawInfo",
            id: 3
          },
          sizeInfo: {
            rule: "repeated",
            type: "SizeInfo",
            id: 4
          }
        }
      },
      SizeInfo: {
        fields: {
          position: {
            type: "string",
            id: 1
          },
          value: {
            type: "double",
            id: 2
          },
          features: {
            type: "Feature",
            id: 3
          }
        }
      },
      FlawInfo: {
        fields: {
          flaw: {
            type: "string",
            id: 1
          },
          extent: {
            type: "string",
            id: 2
          },
          features: {
            type: "Feature",
            id: 3
          }
        }
      },
      Feature: {
        fields: {
          type: {
            type: "string",
            id: 1
          },
          id: {
            type: "string",
            id: 2
          },
          shape: {
            type: "string",
            id: 3
          },
          props: {
            type: "string",
            id: 4
          },
          style: {
            type: "int32",
            id: 5
          },
          remark: {
            type: "string",
            id: 6
          }
        }
      },
      Unit: {
        fields: {
          result: {
            type: "double",
            id: 1
          },
          unit: {
            type: "int32",
            id: 2
          },
          value: {
            type: "int32",
            id: 3
          }
        }
      },
      QualityInspectionFlawResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          inspectionResult: {
            type: "int32",
            id: 3
          },
          level: {
            type: "int32",
            id: 4
          },
          inspectionFlawResult: {
            rule: "repeated",
            type: "InspectionFlawResult",
            id: 5
          }
        }
      },
      QualityInspectionFlawUpdateRequest: {
        fields: {
          inspectionNo: {
            type: "string",
            id: 1
          },
          inspectionResult: {
            type: "int32",
            id: 2
          },
          level: {
            type: "int32",
            id: 3
          },
          qualityInspectionInfo: {
            rule: "repeated",
            type: "QualityInspectionFlawItem",
            id: 4
          }
        }
      },
      QualityInspectionFlawItem: {
        fields: {
          imageName: {
            type: "string",
            id: 1
          },
          flawInfos: {
            rule: "repeated",
            type: "FlawInfo",
            id: 2
          }
        }
      },
      QualityInspectionFlawUpdateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      SizeUpdateRequest: {
        fields: {
          inspectionNo: {
            type: "string",
            id: 1
          },
          inspectionResult: {
            type: "int32",
            id: 2
          },
          level: {
            type: "int32",
            id: 3
          },
          unit: {
            type: "Unit",
            id: 4
          },
          sizeInfo: {
            rule: "repeated",
            type: "SizeItem",
            id: 5
          }
        }
      },
      SizeItem: {
        fields: {
          imageName: {
            type: "string",
            id: 1
          },
          sizeInfos: {
            rule: "repeated",
            type: "SizeInfo",
            id: 2
          }
        }
      },
      SizeUpdateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      GetUserPermissionRequest: {
        fields: {}
      },
      GetUserPermissionResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          permission: {
            type: "bool",
            id: 3
          },
          phone: {
            type: "string",
            id: 4
          }
        }
      },
      VehicleDamageCheckRequest: {
        fields: {
          image: {
            type: "string",
            id: 1
          }
        }
      },
      VehicleDamageCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          id: {
            type: "int32",
            id: 3
          },
          results: {
            rule: "repeated",
            type: "VehicleDamageResult",
            id: 5
          }
        },
        nested: {
          VehicleDamageResult: {
            fields: {
              damageLevel: {
                type: "string",
                id: 1
              },
              partName: {
                type: "string",
                id: 2
              },
              source: {
                type: "string",
                id: 3
              },
              damagePosition: {
                type: "DamagePosition",
                id: 4
              },
              partPosition: {
                type: "DamagePosition",
                id: 5
              }
            }
          },
          DamagePosition: {
            fields: {
              height: {
                type: "int32",
                id: 1
              },
              wight: {
                type: "int32",
                id: 2
              },
              xmin: {
                type: "int32",
                id: 3
              },
              ymin: {
                type: "int32",
                id: 4
              }
            }
          }
        }
      }
    }
  },
  client_grayscale: {
    options: {
      go_package: "./client_pb"
    },
    nested: {
      QueryStrategyRequest: {
        fields: {
          configKey: {
            type: "string",
            id: 1
          }
        }
      },
      QueryStrategyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          data: {
            type: "StrategyResult",
            id: 3
          }
        }
      },
      StrategyResult: {
        fields: {
          strategyCode: {
            type: "string",
            id: 1
          }
        }
      }
    }
  }
});

export { $root as default };
